import { openConsentSettings } from "../lib/consent";

export default function ConsentBadge() {
  return (
    <button
      type="button"
      onClick={openConsentSettings}
      aria-label="Cookie-Einstellungen"
      className={[
        // Position
        "fixed left-4 bottom-26 md:bottom-4 z-[60]",
        // Optik
        "h-11 w-11 rounded-full bg-[#161b27] border border-[#2a3347] shadow-lg",
        "flex items-center justify-center",
        "hover:shadow-xl hover:border-sky-500/30",
        "transition-colors"
      ].join(" ")}
      title="Cookie-Einstellungen"
    >
      <span className="text-xl" aria-hidden>⚙️</span>
    </button>
  );
}
